import Pusher from 'pusher-js';

const pusher = new Pusher('dc316891d7bda149e9e2', {
  cluster: 'sa1',
  forceTLS: true
});

// Función helper para suscribirse a un canal
export function subscribeChannel(channelName) {
  return pusher.subscribe(channelName);
}

// Función helper para bind de eventos
export function bindEvent(channel, eventName, callback) {
  channel.bind(eventName, callback);
}

export default pusher;